import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addToken } from '../actions';
import { useHistory } from 'react-router-dom';
import { saveToken } from '../localStorage';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Alert } from '@material-ui/lab';
import Copyright from '../components/Copyright';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.common.white,
    width: '100%',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Login() {
  const dispatch = useDispatch();
  let history = useHistory();
  const classes = useStyles();
  // Hooks
  // const [loading, setLoading] = useState(false);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    // setLoading(true);
    const data = await fetch(`${process.env.REACT_APP_URL_API}/users/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: loginEmail,
        password: loginPassword,
      }),
    });
    const body = await data.json();
    // setLoading(false);
    if (body.status === 'error') {
      setErrorMsg(body.msg);
    } else {
      saveToken(body.token);
      // localStorage.setItem('token', JSON.stringify(body.token));
      dispatch(addToken(body.token));
      history.push('/abonnements');
    }
  };

  return (
    <Container
      component='main'
      maxWidth='xs'
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper elevation={3} className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Abonnements GAR ISIaccess
        </Typography>
        <form className={classes.form} onSubmit={handleSubmitLogin}>
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            label='E-mail'
            type='email'
            name='email'
            id='email'
            autoComplete='email'
            autoFocus
            value={loginEmail}
            onChange={(e) => setLoginEmail(e.target.value)}
          />
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            label='Mot de passe'
            type='password'
            name='password'
            id='password'
            autoComplete='current-password'
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
          />
          {/* <FormControlLabel
            control={<Checkbox value='remember' color='primary' />}
            label='Remember me'
          /> */}
          {errorMsg && <Alert severity='error'>{errorMsg}</Alert>}
          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            className={classes.submit}
          >
            Se connecter
          </Button>
          {/* <Grid container>
            <Grid item xs>
              <Link href='#' variant='body2'>
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href='#' variant='body2'>
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
        </form>
      </Paper>
      <Box mt={3}>
        <Copyright />
      </Box>
    </Container>
  );
}
